<template>
  <div class="home">
    <div class="section-title">
      <h2>椰椰糕糕🥥🍰你们好香哦~</h2>
      <p>首页不知道放啥，就放点有意义的精美照片记录一下优质时光吧😊</p>
    </div>

    <!-- 时间轴容器 -->
    <div class="timeline-container">
      <div class="timeline-line"></div>

      <!-- 时间轴节点 -->
      <div
        v-for="(event, index) in timelineEvents"
        :key="event.date + '-' + index"
        :class="['timeline-item', index % 2 === 0 ? 'left' : 'right']"
      >
        <!-- 时间轴连接点 -->
        <div class="timeline-dot"></div>

        <div class="timeline-content">
          <!-- 时间点 -->
          <div class="timeline-date">
            <span class="date">{{ event.date }}</span>
            <span class="event-title">{{ event.title }}</span>
          </div>

          <!-- 图片区域 - 简化版 -->
          <div class="image-wrapper">
            <img
              v-lazy="getImageUrl(event.image)"
              :alt="event.title"
              class="lazy-image"
              @click="showLightbox(event)"
            />
          </div>

          <!-- 图片描述 -->
          <p class="image-description">{{ event.description }}</p>
        </div>
      </div>
    </div>

    <!-- 灯箱（点击查看大图） -->
    <div v-if="lightboxVisible" class="lightbox" @click="closeLightbox">
      <div class="lightbox-content" @click.stop>
        <button class="close-btn" @click="closeLightbox">
          <i class="fas fa-times"></i>
        </button>
        <img :src="currentImage" :alt="currentTitle" />
        <div class="lightbox-info">
          <h3>{{ currentTitle }}</h3>
          <p>{{ currentDate }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeView",
  data() {
    return {
      // 时间线数据 - 移除loaded状态
      timelineEvents: [
        {
          date: "2024.9.22",
          title: "第一次见面",
          image: "第一次见面.jpg",
          description: "第一次相遇的美好时刻",
        },
        {
          date: "2024.12.5",
          title: "一起做蜡烛",
          image: "12.7一起做蜡烛.jpg",
          description: "共同制作手工蜡烛",
        },
        {
          date: "2024.12.7",
          title: "一起做义卖活动",
          image: "12.7一起做义卖活动.jpg",
          description: "参加慈善义卖活动",
        },
        {
          date: "2024.12.26",
          title: "狗狗咖啡馆",
          image: "12.26 狗狗咖啡馆.jpg",
          description: "在狗狗咖啡馆的温馨时光",
        },
        {
          date: "2025.1.27",
          title: "双人MV",
          image: "2025年1月27 双人MV.jpg",
          description: "首次合作拍摄音乐MV",
        },
        {
          date: "2025.2.14",
          title: "情人节",
          image: "2025.2.14情人节.jpg",
          description: "情人节特别企划",
        },
        {
          date: "2025.4.1",
          title: "TT锁屏",
          image: "2025.4.1tt锁屏壁纸.jpg",
          description: "TT平台锁屏特别活动",
        },
        {
          date: "2025.4.15",
          title: "甜蜜小韩游",
          image: "4.15一起小韩游.jpg",
          description: "韩国旅行甜蜜时刻",
        },
        {
          date: "2025.4.25",
          title: "Jane和水煮蛋",
          image: "2025.4.25 Jane和水煮蛋.jpg",
          description: "有趣的日常生活分享",
        },
        {
          date: "2025.4.29",
          title: "糕糕生日",
          image: "2025.4.29 糕糕生日.jpg",
          description: "庆祝糕糕的生日",
        },
        {
          date: "2025.5.6",
          title: "首个双人活动（浪琴）",
          image: "2025.5.6 首个双人活动（浪琴）.jpg",
          description: "首次共同参加浪琴品牌活动",
        },
        {
          date: "2025.5.6",
          title: "剧照更新",
          image: "2025.5.6 剧照更新.jpg",
          description: "新剧官方剧照发布",
        },
        {
          date: "2025.6.19",
          title: "叶芷妤生日",
          image: "2025.6.19 小叶生日.jpg",
          description: "为叶芷妤庆祝生日",
        },
        {
          date: "2025.7.29",
          title: "我们的季节Cover上线",
          image: "2025.7.29 我们的季节Cover上线.jpg",
          description: "合作翻唱歌曲正式发布",
        },
        {
          date: "2025.10.1",
          title: "首映",
          image: "2025.10.1 首映.jpg",
          description: "新作品首映礼",
        },
        {
          date: "2025.12.5",
          title: "终映",
          image: "2025.12.5 终映.jpg",
          description: "作品正式完结",
        },
        {
          date: "2025.12.6",
          title: "曼谷见面会",
          image: "2025.12.6见面会.jpg",
          description: "曼谷粉丝见面会现场",
        },
      ],
      lightboxVisible: false,
      currentImage: "",
      currentTitle: "",
      currentDate: "",
    };
  },
  methods: {
    // 获取图片完整路径 - 图片在public/images文件夹中
    getImageUrl(imageName) {
      // 直接返回public/images文件夹中的图片路径
      return `/images/${imageName}`;
    },

    showLightbox(event) {
      this.currentImage = this.getImageUrl(event.image);
      this.currentTitle = event.title;
      this.currentDate = event.date;
      this.lightboxVisible = true;
      document.body.style.overflow = "hidden";
    },

    closeLightbox() {
      this.lightboxVisible = false;
      document.body.style.overflow = "";
    },
  },
};
</script>

<style scoped>
.home {
  max-width: 1200px;
  margin: 0 auto;
  padding: 16px;
}

.section-title {
  text-align: center;
  margin-bottom: 40px;
}

.section-title h2 {
  font-size: 2em;
  margin-bottom: 8px;
  color: #ff6b9d;
  line-height: 1.3;
}

.section-title p {
  color: #888;
  font-size: 1em;
  line-height: 1.5;
  max-width: 800px;
  margin: 0 auto;
}

/* 时间轴容器 */
.timeline-container {
  position: relative;
  padding: 30px 0;
  overflow: hidden;
}

/* 时间轴线 */
.timeline-line {
  position: absolute;
  left: 50%;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(to bottom, #ff6b9d, #4ecdc4);
  transform: translateX(-50%);
  border-radius: 2px;
  z-index: 1;
}

/* 时间轴节点 */
.timeline-item {
  width: 45%;
  margin-bottom: 40px;
  position: relative;
  z-index: 2;
}

/* 时间轴连接点 */
.timeline-dot {
  position: absolute;
  top: 25px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #ff6b9d;
  border: 3px solid white;
  box-shadow: 0 0 0 3px #ff6b9d;
  z-index: 3;
}

.timeline-item.left .timeline-dot {
  right: -42px;
}

.timeline-item.right .timeline-dot {
  left: -42px;
}

.timeline-item.left {
  float: left;
  clear: left;
  padding-right: 32px;
  text-align: right;
}

.timeline-item.right {
  float: right;
  clear: right;
  padding-left: 32px;
  text-align: left;
}

.timeline-content {
  background: white;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
}

.timeline-content:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.timeline-date {
  margin-bottom: 15px;
  position: relative;
  z-index: 4;
}

.timeline-date .date {
  display: block;
  font-weight: 600;
  color: #ff6b9d;
  font-size: 1em;
  margin-bottom: 6px;
  background: white;
  padding: 2px 8px;
  display: inline-block;
  border-radius: 4px;
  line-height: 1.3;
}

.timeline-date .event-title {
  font-size: 1.2em;
  font-weight: 600;
  color: #333;
  background: white;
  padding: 4px 10px;
  display: inline-block;
  border-radius: 6px;
  line-height: 1.3;
}

/* 图片区域 */
.image-wrapper {
  position: relative;
  overflow: hidden;
  border-radius: 8px;
  cursor: pointer;
  background: #f8f8f8;
  margin-bottom: 12px;
  min-height: 220px;
}

/* 懒加载图片样式 */
.lazy-image {
  width: 100%;
  height: 280px;
  object-fit: cover;
  transition: transform 0.3s ease, opacity 0.3s ease;
  display: block;
}

.lazy-image[lazy="loading"] {
  opacity: 0;
}

.lazy-image[lazy="loaded"] {
  opacity: 1;
  animation: fadeIn 0.3s ease;
}

.lazy-image[lazy="error"] {
  opacity: 1;
}

.lazy-image:hover {
  transform: scale(1.02);
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.image-description {
  margin-top: 12px;
  color: #666;
  font-size: 0.9em;
  line-height: 1.5;
  padding: 8px;
  background: #f9f9f9;
  border-radius: 6px;
}

/* 灯箱样式 */
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.lightbox-content {
  max-width: 90%;
  max-height: 90%;
  position: relative;
  animation: zoomIn 0.3s ease;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    transform: scale(0.8);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.lightbox-content img {
  max-width: 100%;
  max-height: 80vh;
  border-radius: 8px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.close-btn {
  position: absolute;
  top: -40px;
  right: 0;
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 6px;
  transition: color 0.3s;
}

.close-btn:hover {
  color: #ff6b9d;
}

.lightbox-info {
  color: white;
  text-align: center;
  margin-top: 16px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  backdrop-filter: blur(5px);
}

.lightbox-info h3 {
  margin-bottom: 4px;
  font-size: 1.2em;
}

.lightbox-info p {
  font-size: 0.9em;
  opacity: 0.9;
}

/* 响应式设计 */
@media (max-width: 992px) {
  .timeline-item {
    width: 47%;
  }

  .home {
    padding: 14px;
  }
}

@media (max-width: 768px) {
  /* 移动端时间轴改为单列布局 */
  .timeline-line {
    left: 20px;
  }

  .timeline-dot {
    left: 12px !important;
    right: auto !important;
    width: 14px;
    height: 14px;
    border-width: 2px;
    box-shadow: 0 0 0 2px #ff6b9d;
    top: 22px;
  }

  .timeline-item {
    width: calc(100% - 40px);
    margin-left: 40px;
    float: none !important;
    padding: 0 !important;
    text-align: left !important;
    margin-bottom: 32px;
  }

  .timeline-item.left,
  .timeline-item.right {
    clear: both;
  }

  /* 确保连接点不会遮挡内容 */
  .timeline-content {
    margin-left: 8px;
    padding: 16px 16px 16px 20px;
  }

  .timeline-date {
    padding-left: 0;
  }

  .timeline-date .date {
    padding: 2px 8px;
    font-size: 0.95em;
  }

  .timeline-date .event-title {
    font-size: 1.1em;
    padding: 3px 10px;
    line-height: 1.3;
    display: block;
    margin-top: 4px;
  }

  .home {
    padding: 12px;
  }

  .lazy-image {
    height: 250px;
  }

  .image-wrapper {
    min-height: 180px;
  }

  .section-title {
    margin-bottom: 30px;
  }

  .section-title h2 {
    font-size: 1.6em;
    margin-bottom: 6px;
  }

  .section-title p {
    font-size: 0.9em;
  }

  .image-description {
    font-size: 0.85em;
    padding: 6px;
  }
}

/* 超小屏幕优化 */
@media (max-width: 480px) {
  .timeline-line {
    left: 16px;
  }

  .timeline-dot {
    left: 9px !important;
    width: 12px;
    height: 12px;
    border-width: 2px;
    box-shadow: 0 0 0 2px #ff6b9d;
    top: 20px;
  }

  .timeline-item {
    width: calc(100% - 32px);
    margin-left: 32px;
    margin-bottom: 28px;
  }

  .timeline-content {
    padding: 14px 14px 14px 16px;
    margin-left: 4px;
  }

  .timeline-date .date {
    font-size: 0.9em;
    padding: 1px 6px;
  }

  .timeline-date .event-title {
    font-size: 1em;
    padding: 2px 8px;
    line-height: 1.3;
  }

  .lazy-image {
    height: 220px;
  }

  .image-wrapper {
    min-height: 160px;
  }

  .section-title h2 {
    font-size: 1.4em;
  }

  .section-title p {
    font-size: 0.85em;
  }

  .home {
    padding: 10px;
  }

  .lightbox-info h3 {
    font-size: 1.1em;
  }

  .lightbox-info p {
    font-size: 0.85em;
  }
}

/* 超小屏幕优化 - 防止文字被遮挡 */
@media (max-width: 360px) {
  .timeline-line {
    left: 14px;
  }

  .timeline-dot {
    left: 7px !important;
    width: 10px;
    height: 10px;
    top: 18px;
  }

  .timeline-item {
    width: calc(100% - 28px);
    margin-left: 28px;
    margin-bottom: 24px;
  }

  .timeline-content {
    padding: 12px 12px 12px 14px;
    margin-left: 2px;
  }

  .timeline-date .event-title {
    font-size: 0.95em;
    padding: 2px 6px;
  }

  .image-description {
    font-size: 0.8em;
    padding: 5px;
  }

  .lazy-image {
    height: 200px;
  }

  .image-wrapper {
    min-height: 140px;
  }

  .section-title h2 {
    font-size: 1.3em;
  }
}
</style>
